'use client'

import { useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import { ICategory } from '@/app/[locale]/_types'

const MoreBtn = ({
  showImage,
  ...props
}: {
  showImage: boolean
  hasFilter?: boolean
  count?: number | string
  data: ICategory[]
  hasNextPage?: boolean
  fetchNextPage?: () => void
  isFetchingNextPage?: boolean
}) => {
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )
  return isDesktop ? (
    <Desktop {...props} />
  ) : (
    <Mobile showImage={showImage} {...props} />
  )
}

export default MoreBtn
